<template>
    <div>
        <a
            v-if="isReviewHaveResponse"
            href="#"
            class="text-primary response"
            @click.prevent="showReviewResponseModal"
        >
            {{ reviewResponse }}
        </a>
        <responsive-button
            v-else-if="review.review_response_status === REVIEW_STATUS_PENDING"
            :icon="['far', 'paper-plane']"
            variant="outline-primary"
            title="Send a response"
            :responsiveness="false"
            size="sm"
            @click="showSendResponseModal"
        >
            Send a response
        </responsive-button>
        <responsive-button
            v-else-if="review.review_response_status === REVIEW_STATUS_EXPIRES_SOON"
            :icon="['far', 'paper-plane']"
            variant="outline-danger"
            title="Send a response (expires soon)"
            :responsiveness="false"
            size="sm"
            @click="showSendResponseModal"
        >
            Send a response (expires soon)
        </responsive-button>
        <validation-observer ref="form" v-slot="{ handleSubmit, meta }">
            <modal
                :id="sendResponseModalId"
                title="Send Response"
                :ok-disabled="!meta.valid"
                @ok.prevent="sendResponse"
                @hidden="hidden"
                ok-title="Send"
            >
                <busy-modal :show="loading"></busy-modal>
                <b-form @submit.prevent="handleError(_, sendResponse)">
                    <validation-provider name="response" rules="required" v-slot="{ errors, handleChange }" >
                        <form-textarea v-model="response" rows="3" floatingLabel="Response" :error="errors[0]" @input="handleChange" />
                    </validation-provider>
                </b-form>
            </modal>
        </validation-observer>
        <modal :id="reviewResponseModalId" title="Response" ok-only @hidden="hidden" ok-title="Close">
            {{ reviewResponse }}
        </modal>
    </div>
</template>

<script>
import API from '../../../../../api.jsx';
import BusyModal from '../../../../generic/busy-modal/busy-modal.vue';
import { formatResponseError } from '../../../../../utils/api';
import FormTextarea from '../../../../generic/form-textarea/form-textarea.vue';
import isEmpty from 'lodash/isEmpty';
import Modal from '../../../../generic/modal/modal.vue';
import ResponsiveButton from '../../../../generic/responsive-button/responsive-button.vue';
import { REVIEW_STATUS_EXPIRES_SOON, REVIEW_STATUS_PENDING } from '../../../../../constants';
import { PARTNER_AIRBNB_HOST_REVIEW_RESPOND_TO_REVIEW_ENDPOINT } from '../../../../../endpoints';

export default {
    components: { BusyModal, FormTextarea,  Modal, ResponsiveButton },
    data() {
        return {
            loading: false,
            sendResponseModalId: null,
            reviewResponseModalId: null,
            review: null,
            response: '',
            REVIEW_STATUS_EXPIRES_SOON,
            REVIEW_STATUS_PENDING,
        };
    },
    created() {
        this.sendResponseModalId = `send-response-modal-id-${this.params.data.id}`;
        this.reviewResponseModalId = `review-response-modal-id-${this.params.data.id}`;
        this.review = this.params.data;
    },
    computed: {
        isReviewHaveResponse() {
            return this.review?.airbnb_host_review_response ? true : false;
        },
        reviewResponse() {
            return this.isReviewHaveResponse ? this.review.airbnb_host_review_response.response : ''
        }
    },
    methods: {
        showSendResponseModal() {
            this.$bvModal.show(this.sendResponseModalId);
        },
        showReviewResponseModal() {
            this.$bvModal.show(this.reviewResponseModalId);
        },
        async sendResponse() {
            this.loading = true;
            try {
                const { data } = await API.post(
                    PARTNER_AIRBNB_HOST_REVIEW_RESPOND_TO_REVIEW_ENDPOINT(this.review.id),
                    {
                        response: this.response,
                    }
                );
                this.params.setReview(data);
                this.successToast({
                    text: 'Response successfully sent.',
                });
                this.$bvModal.hide(this.sendResponseModalId);
            } catch (error) {
                const { generic, fields } = formatResponseError(error);
                this.errorToast({
                    text: generic || 'Could not send response.',
                });
                if (!isEmpty(fields)) {
                    this.$refs.form.setErrors(fields);
                }
            } finally {
                this.loading = false;
            }
        },
        hidden() {
            this.response = '';
        },
    },
};
</script>

<style lang="scss" scoped>
.response {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: underline;
}
</style>
